/**
 * @desc 根据按钮查询 页面以及按钮
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  ObjectMap<string, Array<defs.appCenter.ButtonAggregateResponseDto>>
>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/menu/getPageAndButton`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
